import React from 'react';
import { useSelector } from 'react-redux';
import { Forms, TitleBar } from '@salesperformanceint/e4shared';
import PageHeader from '../../components/general/pageHeader';
import Package from '../../../package.json';

const { detect } = require('detect-browser');
const browser = detect() || {};

export const Support = () => {
    const { administrator, authority, crmIntegration, currencySymbol, full_Name, spoofing, version } = useSelector(
        state => state.user.user
    );
    return (
        <div>
            <PageHeader title="Support" />
            <div className="row">
                <div className="col-md-6">
                    <TitleBar title="User Details" />
                    <Forms.Label label="Name" value={full_Name} />
                    <Forms.Label label="Administrator" value={administrator ? 'Yes' : 'No'} />
                    <Forms.Label label="Authority" value={authority} />
                    <Forms.Label label="CRM" value={crmIntegration} />
                    <Forms.Label label="Currency Symbol" value={currencySymbol} />
                    <Forms.Label label="Spoofing" value={spoofing ? 'Yes' : 'No'} />
                </div>
                <div className="col-md-6">
                    <TitleBar title="System Details" />
                    <Forms.Label label="Browser" value={browser.name} />
                    <Forms.Label label="Browser Version" value={browser.version} />
                    <Forms.Label label="Web Version" value={Package.version} />
                    <Forms.Label label="API Version" value={version} />
                    <Forms.Label label="OS" value={browser.os} />
                </div>
            </div>
        </div>
    );
};

export default Support;
